import React, { ReactNode } from 'react';

import { Badge } from '@travel/ui';
import { cx } from '@travel/utils';

import styles from './iconButtonWithBadge.module.scss';

type Props = {
  className: string;
  onClick: () => void;
  icon: ReactNode;
  number?: number | null;
};

function IconButtonWithBadge(props: Props) {
  const { className, onClick, icon, number, ...rest } = props;

  return (
    <button type="button" onClick={onClick} className={cx(styles.wrapper, className)} {...rest}>
      {icon}
      {typeof number === 'number' && number > 0 && (
        <Badge number={number} className={styles.badgeWrapper} />
      )}
    </button>
  );
}

export default IconButtonWithBadge;
